import { BoxProps, ResponsiveValue } from "@smile2impress/components";

export type TrustpilotConfig = {
    "data-locale"?: string;
    "data-template-id": string;
    "data-style-height": string;
    "data-style-width": string;
    "data-theme"?: string;
    style?: Record<string, string>;
};

export type TrustpilotStyle =
    | TrustpilotConfig
    | ((locale: string) => TrustpilotConfig);

/**
 * @see <a href="https://support.trustpilot.com/hc/en-us/articles/360019826379-TrustBox-widget-overview">TrustBox widget overview</a>
 */
export enum TrustpilotWidgetVariant {
    /**
     * {@link https://support.trustpilot.com/hc/en-us/articles/360019826379-TrustBox-widget-overview#micro-trustscore-7}
     */
    MICRO_TRUST_SCORE = "MICRO_TRUST_SCORE",
    /**
     * {@link https://support.trustpilot.com/hc/en-us/articles/360019826379-TrustBox-widget-overview#mini-8}
     */
    MINI = "MINI",
    /**
     * {@link https://support.trustpilot.com/hc/en-us/articles/360019826379-TrustBox-widget-overview#quote-19}
     */
    QUOTE = "QUOTE",
    /**
     * {@link https://support.trustpilot.com/hc/en-us/articles/360019826379-TrustBox-widget-overview#carousel-11}
     */
    CAROUSEL = "CAROUSEL",
}

export enum TrustpilotWidgetTheme {
    LIGHT = "light",
    DARK = "dark",
}

export interface TrustpilotProps extends BoxProps {
    link: string;
    variant?: ResponsiveValue<TrustpilotWidgetVariant>;
    theme?: ResponsiveValue<TrustpilotWidgetTheme>;
}

declare global {
    interface Window {
        Trustpilot: any;
    }
}
